<template>
  <ul>
    <li>
      <div class="relative bg-white shadow-md px-5 py-8 flex flex-col gap-4">
        <div class="flex flex-row gap-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 32" class="w-7 h-7 shrink-0">
            <g id="clipboard" transform="translate(-3)">
              <path
                id="Path_4890"
                data-name="Path 4890"
                d="M19,4a3,3,0,0,0-6,0H10V8H22V4Z"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                id="Path_4891"
                data-name="Path 4891"
                d="M25,5h3V31H4V5H7"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <line
                id="Line_317"
                data-name="Line 317"
                x2="15"
                transform="translate(8.5 14.5)"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-width="1"
              />
              <line
                id="Line_318"
                data-name="Line 318"
                x2="15"
                transform="translate(8.5 19.5)"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-width="1"
              />
              <line
                id="Line_319"
                data-name="Line 319"
                x2="15"
                transform="translate(8.5 24.5)"
                fill="none"
                stroke="#991e66"
                stroke-linecap="round"
                stroke-width="1"
              />
            </g>
          </svg>
          <BaseTypography disable-ellipsis class="text-sm font-medium">
            {{ $t("pages.account.drawer.guest.go_to_patient_area") }}
          </BaseTypography>
        </div>
        <a :href="resultsUrl" target="_blank" class="block">
          <BaseButton variant="contained" class="capitalize w-full">
            {{ $t("pages.account.drawer.guest.your_test_results") }}
          </BaseButton>
        </a>
      </div>
    </li>

    <li v-if="isHomeTestEnabled">
      <NuxtLinkLocale
        :locale="switchBlogLocale()"
        to="/account/login"
        @click="closeAccountDrawer"
        class="flex flex-col gap-4 px-6 py-4 hover:bg-slate-100"
      >
        <div class="flex flex-row gap-4 items-center">
          <NuxtImg src="/icons/arrow-right-secondary.svg" width="12" heigth="10" />
          <BaseTypography class="font-semibold">{{ $t("pages.account.drawer.guest.account_login") }}</BaseTypography>
        </div>
        <BaseTypography disable-ellipsis class="text-sm">
          {{ $t("pages.account.drawer.guest.account_optional_text") }}
          <br />
          <br />
          {{ $t("pages.account.drawer.guest.results_portal_text") }}
        </BaseTypography>
      </NuxtLinkLocale>
    </li>
  </ul>
</template>

<script setup lang="ts">
const testResults = useTestResults();
const resultsUrl = testResults.resultsUrl;

function closeAccountDrawer() {
  const trigger = document.getElementById("accountDrawerTrigger");
  trigger?.click();
}

const globalStore = useGlobalStore();
const isHomeTestEnabled = computed(() => globalStore.isHomeTestEnabled);
</script>

<style scoped lang="scss">
ul > li {
  @apply border-b;
}
</style>
